export const getRandomImageIndex = () => {
  const imageIndices = [0, 1, 2, 4, 5, 8, 9, 11]; // 3, 6, 7, 10 omitted
  return imageIndices[Math.floor(Math.random() * imageIndices.length)];
};
